const _vieraLua = `local VERSION = "Driver Version"
local APP_ID  = "[[APP_ID]]"

function ReceivedFromProxy(idBinding, strCommand, tParams)
    if (strCommand == "ON" or strCommand == "OFF" or strCommand == "CANCEL") then return end

    if (strCommand == "GET_APP_ID") then
        tParams       = tParams or {}
        tParams.AppID = APP_ID

        C4:SendToProxy(1, "APP_ID", tParams)

        return
    end

    C4:SendToProxy(1, strCommand, tParams)
end

function ExecuteCommand(strCommand, tParams)
    C4:SendToProxy(1, strCommand, tParams)
end

function OnDriverLateInit()
    C4:UpdateProperty(VERSION, "0.0.[[VERSION]]")
end`

const _vieraXml = `<devicedata>
<copyright>Copyright 2019 annex4.  All rights reserved.</copyright>
<creator>annex4</creator>
<manufacturer>VIErA</manufacturer>
<name>[[APP_NAME]] - VIErA</name>
<model>[[APP_NAME]]</model>
<created>[[DATE_TIME]]</created>
<modified>[[DATE_TIME]]</modified>
<version>[[VERSION]]</version>
<small image_source="c4z">icons/device_sm.png</small>
<large image_source="c4z">icons/device_lg.png</large>
<capabilities>
    <navigator_display_option proxybindingid="5001">
        <display_icons>
            <Icon height="1024" width="1024">controller://driver/[[FILENAME]]/icons/device/experience_1024.png</Icon>
            <Icon height="512" width="512">controller://driver/[[FILENAME]]/icons/device/experience_512.png</Icon>
            <Icon height="300" width="300">controller://driver/[[FILENAME]]/icons/device/experience_300.png</Icon>
            <Icon height="90" width="90">controller://driver/[[FILENAME]]/icons/device/experience_90.png</Icon>
            <Icon height="70" width="70">controller://driver/[[FILENAME]]/icons/device/experience_70.png</Icon>
        </display_icons>
    </navigator_display_option>
</capabilities>
<control>lua_gen</control>
<driver>DriverWorks</driver>
<proxies qty="1">
    <proxy proxybindingid="5001" primary="True" name="[[APP_NAME]]" image_source="c4z" small_image="icons/device_sm.png" large_image="icons/device_lg.png">media_player</proxy>
</proxies>
<connections>
    <connection proxybindingid="5001">
        <id>2001</id>
        <connectionname>[[APP_NAME]] Out</connectionname>
        <type>5</type>
        <consumer>False</consumer>
        <linelevel>True</linelevel>
        <classes>
            <class>
                <classname>HDMI</classname>
            </class>
        </classes>
    </connection>
    <connection>
        <id>5001</id>
        <type>2</type>
        <connectionname>MEDIA_PLAYER</connectionname>
        <consumer>False</consumer>
        <linelevel>False</linelevel>
        <classes>
            <class>
                <classname>MEDIA_PLAYER</classname>
            </class>
        </classes>
    </connection>
    <connection>
        <id>1</id>
        <facing>6</facing>
        <type>1</type>
        <connectionname>VIErA Mini Driver</connectionname>
        <consumer>True</consumer>
        <linelevel>True</linelevel>
        <classes>
            <class>
                <classname>VIErA</classname>
            </class>
        </classes>
    </connection>
</connections>
<config>
    <documentation></documentation>
    <script file="driver.lua"></script>
    <properties>
        <property>
            <name>Driver Version</name>
            <type>STRING</type>
            <readonly>true</readonly>
            <default/>
        </property>
    </properties>
</config>
</devicedata>`

export const vieraXml = _vieraXml
export const vieraLua = _vieraLua

export default {
    vieraXml: vieraXml,
    vieraLua: vieraLua
}